// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5641":"4dfa2e3f2030ae9f","87166":"2d9a49cc33e195ed"}[chunkId] + ".css";
};